module.exports = {
  NODE_ENV: '"production"'
}



//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = 43
// module chunks = 1